// TODO: remove this when we split server and client-side data fetching

export default (name = '@gumtree/logger') => ({
    info: (...args) => console.log(name, ...args),
    error: (...args) => console.log(name, ...args),
    debug: (...args) => console.log(name, ...args),
    warn: (...args) => console.log(name, ...args),
    structured: (event, sourceFileName, data) =>
        console.log(name, 'structured', sourceFileName, event, JSON.stringify(data)),
});
